export function formatDocumentoDisplay(data) {
  const numero = String(data?.Documento || data?.ci || "").trim();
  if (!numero) return "—";
  const tipo = String(data?.tipoDocumento || "CI").trim() || "CI";
  return `${tipo} ${numero}`;
}

